export default __webpack_public_path__ + "static/media/28.c5a64a1a.jpeg";